
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Controls / Checkbox / Small / Checked","xmlns":"http://www.w3.org/2000/svg","width":"37","height":"37"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Controls / Checkbox / Unchecked"}},[_c('rect',{attrs:{"data-name":"Rectangle Copy 3","width":"37","height":"37","rx":"18.5","fill":"#fc6b36"}}),_c('path',{attrs:{"d":"M30.015 9.204a1.156 1.156 0 011.747 1.506l-.112.13-16.958 16.957a1.157 1.157 0 01-1.506.112l-.13-.112-7.707-7.708a1.156 1.156 0 011.505-1.747l.13.112 6.891 6.89z","fill":"#fff"}})])])
          )
        }
      }
    